import { Link, useNavigate } from "react-router-dom";
import NoData from "../../assets/img/nodata_green.svg";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  TypeDonationLinkCollection,
  fetchDonationLinks,
  //resetCursor,
  selectDonationLinks,
} from "../../features/donationlinks/donationLinksSlice";

import {
  TypeNtumaDigitalItem,
  fetchNtumaDigitalItems,
  resetCursor,
  selectNtumaDigitalItems,
} from "../../features/ntumadigitalItems/ntumaDigitalItemssSlice";
import { useEffect, useState } from "react";
import { formatDate } from "../../helpers/commons";
import {
  selectNtumaAccount,
  selectAccessToken,
  selectActiveEnvironment,
} from "../../features/auth/authSlice";
import AppSpinner from "../elements/AppSpinner";
import { APP_STATUS } from "../../helpers/constants";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import useApiRequest from "../../helpers/api_request";
import { SHORTEN_URL, BASE_URL } from "../../helpers/constants";
import { AxiosError } from "axios";

const NtumaDigitalLinksPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  //const donationLinks = useAppSelector(selectDonationLinks)
  const ntumaDigitalItems = useAppSelector(selectNtumaDigitalItems);
  const ntumaAccount = useAppSelector(selectNtumaAccount);
  //const loadingLinksStatus = useAppSelector(state=>state.donationLinks.loadingLinksStatus)
  const loadingLinksStatus = useAppSelector(
    (state) => state.ntumaDigitalItems.loadingItemsStatus
  );
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = useAppSelector((state) => state.donationLinks.totalPages);
  const landingUrl = process.env.REACT_APP_LANDING_URL;

  const apiRequest = useApiRequest();
  const [longUrl, setLongUrl] = useState("");

  const accessToken = useAppSelector(selectAccessToken);
  const activeEnvironment = useAppSelector(selectActiveEnvironment);

  useEffect(() => {
    dispatch(resetCursor());
    //dispatch(fetchDonationLinks())
    dispatch(fetchNtumaDigitalItems());
  }, [ntumaAccount]);

  const sumCollections = (data: TypeDonationLinkCollection[]): string => {
    let totalAmount = 0;
    for (const item of data) {
      if (item.collection) {
        if (item.collection.status === "successful") {
          totalAmount += item.collection.amount;
        }
      }
    }
    return totalAmount.toLocaleString();
  };

  const copyLink = (value: string) => {
    dispatch(
      showToastMessage({
        message: "Copied",
        type: "success",
        position: toast.POSITION.TOP_RIGHT,
      })
    );
    navigator.clipboard.writeText(value);
  };

  useEffect(() => {
    if (longUrl) {
      const fetchShortenedUrl = async () => {
        const apiUrl = SHORTEN_URL.API_HOST;
        const toastLoader = toast.loading("Processing"); // This shows the loading toast

        try {
          const response = await apiRequest({
            method: "post",
            url: apiUrl + "api/shorten_url",
            headers: { "Content-Type": "application/json" },
            data: {
              long_url: longUrl,
            },
          });

          toast.dismiss(toastLoader); // Dismiss toast after response

          if (response.status === "SUCCESS") {
            const getShortenedUrl = response.short_url;

            copyLink(getShortenedUrl);
          } else {
            dispatch(
              showToastMessage({
                message: response.message,
                type: "error",
                position: toast.POSITION.TOP_RIGHT,
              })
            );
          }
        } catch (error) {
          dispatch(
            showToastMessage({
              message: "Failed to process shortened URL.",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } finally {
          toast.dismiss(toastLoader); // Ensure toast is dismissed even if error
        }
      };

      fetchShortenedUrl();
    }
  }, [longUrl]);

  const [ntumaDigitalItemId, setNtumaDigitalItemId] = useState<
    number | string | null
  >(null);

  useEffect(() => {
    if (ntumaDigitalItemId === null) return;

    const deleteProduct = async () => {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this product?"
      );
      if (!confirmDelete) return;

      /*
    try {
      console.log("Deleting product with id:", ntumaDigitalItemId);

      
      await fetch(`/api/ntuma-digital-item/${ntumaDigitalItemId}`, { method: "DELETE" });

      alert("Product deleted successfully!");



      setNtumaDigitalItemId(null); // reset
      navigate("/ntuma-digital-items"); // redirect to list
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Failed to delete product. Please try again.");
      setNtumaDigitalItemId(null);
      hide_digital_item
      "/api/donation-link/hide_digital_item/" +
    }*/

      /* let deleteUrl =
        BASE_URL +
        "/api/donation-link/delete_digital_item/" +
        ntumaDigitalItemId;*/

      let deleteUrl =
        BASE_URL + "/api/donation-link/hide_digital_item/" + ntumaDigitalItemId;

      const toastLoader = toast.loading("Processing");
      const shouldHide = true;
      //const env="prod";
      const env = activeEnvironment === "test" ? "test" : "prod";

      console.log("DATAS_HIDE_VALUE" + JSON.stringify(shouldHide));

      apiRequest({
        method: "post",
        url: deleteUrl,
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        data: {
          ntumaDigitalItemId,
          shouldHide,
          env,

          // required
        },
      })
        .then((response) => {
          console.log("ITEM-DELETE/HIDE" + JSON.stringify(response));
          dispatch(
            showToastMessage({
              message: "Product deleted!",
              type: "success",
              position: toast.POSITION.TOP_RIGHT,
            })
          );

          dispatch(resetCursor());

          dispatch(fetchNtumaDigitalItems());

          //setSavingLinkStatus(false);
          toast.dismiss(toastLoader);
          navigate("/ntuma-digital-items"); // redirect to list
        })
        .catch((error) => {
          console.log("ITEMS" + JSON.stringify(error));
          const errorResponse = error as AxiosError;
          if (errorResponse.response) {
            const data = errorResponse.response.data as {
              message: string;
              status: string;
            };
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error("Something went wrong", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          toast.dismiss(toastLoader);
          //setSavingLinkStatus(false);
        });
    };

    deleteProduct();
  }, [ntumaDigitalItemId]);

  return (
    <div>
      <div className="card mb-12">
        <div className="card-body flex flex-col px-4 py-4 min-h-half-screen pb-16">
          <div className="flex">
            <nav className="flex justify-between " aria-label="Breadcrumb">
              <ol className="inline-flex items-center mb-3 sm:mb-0">
                <li>
                  <div className="flex items-center">
                    <h5 className=" card-title ">Ntuma Digital Items</h5>
                  </div>
                </li>
              </ol>
            </nav>
            <div className="flex-grow flex justify-end">
              <button
                onClick={() => navigate("/new-ntuma-digital-item")}
                type="button"
                className="prim-btn-1 mb-2"
              >
                New Item/Product
              </button>
            </div>
          </div>

          {ntumaDigitalItems.length === 0 &&
            loadingLinksStatus !== APP_STATUS.PENDING && (
              <div className="h-fit flex-grow flex flex-col justify-center">
                <div className="flex justify-center">
                  <div>
                    <img className="w-32" src={NoData} alt="" />
                    <p>No Items Yet!</p>
                  </div>
                </div>
              </div>
            )}
          {ntumaDigitalItems.length > 0 && (
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead>
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col">Type</th>
                  <th scope="col">Category</th>
                  <th scope="col">Price</th>
                  <th scope="col">Original Price</th>
                  <th scope="col">Description</th>

                  <th></th>
                </tr>
              </thead>
              <tbody>
                {ntumaDigitalItems.map((item, key) => (
                  <tr key={key}>
                    <td className="max-w-[200px]">{item.title}</td>
                    <td>
                      {item.type
                        ? item.type.charAt(0).toUpperCase() + item.type.slice(1)
                        : "_"}
                    </td>

                    <td>{item.category || "—"}</td>
                    <td>
                      {item.price && item.price > 0 ? (
                        <div>{item.price.toLocaleString()}</div>
                      ) : (
                        "—"
                      )}
                    </td>

                    <td>
                      {item.original_price && item.original_price > 0 ? (
                        <s>{item.original_price.toLocaleString()}</s>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td>{item.description || "—"}</td>

                    <td>
                      <i
                        className="fa fa-trash text-red-500 cursor-pointer"
                        onClick={() => setNtumaDigitalItemId(item.id)}
                      ></i>
                    </td>

                    <td>
                      <a
                        onClick={() =>
                          copyLink(landingUrl + "/checkout/" + item.ref)
                        }
                        href="#!"
                        className="font-medium text-prim-green  hover:underline"
                      >
                        copy
                      </a>
                    </td>

                    <td>
                      <Link
                        to={"#"}
                        className="fa fa-link text-gray-500 ml-3 text-xs"
                        onClick={() => {
                          const generatedUrl =
                            landingUrl + "/checkout/" + item.ref;
                          setLongUrl(generatedUrl);
                        }}
                      ></Link>
                    </td>

                    {/*
                     <td>{formatDate(item.created_at, "MMM DD, YYYY H:mm")}</td>
                     */}

                    <td>
                      <div className="">
                        <Link
                          to={`/ntuma-digital-items/edit/${item.ref}`}
                          className="fa fa-edit text-gray-500 ml-2 text-xs"
                        ></Link>

                        {/*
                        <Link
                          to={"#"}
                          className="fa fa-link text-gray-500 ml-3 text-xs"
                          onClick={() => {
                            const generatedUrl =
                              landingUrl + "/fund/" + item.ref;
                            setLongUrl(generatedUrl);
                          }}
                        ></Link>
                        */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {loadingLinksStatus === APP_STATUS.PENDING && <AppSpinner />}
          {currentPage < totalPages && (
            <div className=" flex justify-center mt-16">
              <button
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                  dispatch(fetchNtumaDigitalItems());
                }}
                type="button"
                className="btn-light text-gray-600 "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  className=" text-gray-600"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M14 16h5v5M10 8H5V3m14.418 6.003A8 8 0 0 0 5.086 7.976m-.504 7.021a8 8 0 0 0 14.331 1.027"
                  />
                </svg>
                <span className="pl-1">Load More</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default NtumaDigitalLinksPage;
